export * from './honorar-vereinbarung-delete-request.interface';
export * from './honorar-vereinbarung-delete-response.interface';
export * from './honorar-vereinbarung-delete.shapes';
